module.exports = __webpack_public_path__ + "img/icon_status_refused_pass.dac7dca3.png";